import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useIsMobile } from "../../../hooks/useIsMobile";
import {
  HeaderNav,
  NavContainer,
  NavItem,
  NavLink,
  NavList,
  NavLogo,
  NavMenu,
} from "./NavbarElements";

const Navbar = ({ darkMode, handleTermnialOpen }) => {
  const [scrollNav, setScrollNav] = useState(false);
  const [isTerminalClick, setIsTerminalClick] = useState(false);
  const [activeNav, setActiveNav] = useState("home");
  const [isAtBottom, setIsAtBottom] = useState(false);
  const isMobile = useIsMobile();

  const navItems = [
    { id: "home", icon: "bx bx-home" },
    { id: "about", icon: "bx bx-user" },
    { id: "skills", icon: "bx bx-code-alt" },
    { id: "works", icon: "bx bx-briefcase" },
    { id: "certification", icon: "bx bx-notepad" },
    { id: "contact", icon: "bx bx-user-voice" },
  ];

  const changeNav = () => {
    if (window.scrollY >= 30) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }

    // Check if we're close to the footer
    const windowHeight = window.innerHeight;
    const documentHeight = document.body.scrollHeight;
    const scrollPosition = window.scrollY + windowHeight;
    const buffer = 150; // Adjust this value to change when the nav hides

    if (documentHeight - scrollPosition < buffer) {
      setIsAtBottom(true);
    } else {
      setIsAtBottom(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeNav);
    return () => {
      window.removeEventListener("scroll", changeNav);
    };
  }, []);

  const handleChange = () => {
    setIsTerminalClick(!isTerminalClick);
    handleTermnialOpen(!isTerminalClick);

    if (isMobile) {
      // Could add a modal or toast message here if wanted
      console.log("Terminal mode has limited functionality on mobile devices");
    }
  };

  const handleSetActive = (to) => {
    setActiveNav(to);
  };

  return (
    <>
      <HeaderNav light={darkMode ? 1 : 0} scrollNav={scrollNav}>
        <NavContainer>
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <NavLogo
              to="home"
              smooth={true}
              duration={100}
              spy={true}
              offset={-30}
            >
              rojan.dev
            </NavLogo>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <NavLogo
              onClick={handleChange}
              smooth={true}
              duration={100}
              spy={true}
              offset={-30}
            >
              {isMobile ? "</try terminal>" : "</terminal mode>"}
            </NavLogo>
          </motion.div>
        </NavContainer>
      </HeaderNav>

      {/* Separate dock navigation that's always fixed at bottom */}
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.6 }}
          className="navigation-dock fixed left-0 right-0 bottom-6 z-[999] mx-auto flex justify-center"
        >
          <NavMenu light={darkMode ? 1 : 0}>
            <NavList>
              {navItems.map((item) => (
                <NavItem key={item.id}>
                  <NavLink
                    to={item.id}
                    light={darkMode ? 1 : 0}
                    smooth={true}
                    duration={500}
                    spy={true}
                    offset={
                      item.id === "certification" || item.id === "contact"
                        ? -80
                        : -30
                    }
                    onSetActive={handleSetActive}
                    className={activeNav === item.id ? "active" : ""}
                  >
                    <motion.i
                      className={item.icon}
                      whileHover={{ scale: 1.2 }}
                      whileTap={{ scale: 0.9 }}
                    ></motion.i>
                  </NavLink>
                </NavItem>
              ))}
            </NavList>
          </NavMenu>
        </motion.div>
      </AnimatePresence>
    </>
  );
};

export default Navbar;
